const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import ECheckinForm from 'App/config/uster/eCheckin/ECheckinForm';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/uster/Footer';
import textMap from './translations';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: undefined,
    welcomeTitle: textMap.welcomeTitle,
    welcomeText: textMap.welcomeText,
    synedraCardTitle: textMap.synedraCardTitle,
    urls: {
        website: 'https://www.spitaluster.ch',
        loginHelp: undefined,
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
    },
    customMatomoClientId: undefined,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
